import { Base } from "../../framework/base";
import { t } from "i18next";
import { IAutocompleteItem } from "../framework/autocomplete";

export enum MainGroupType {
    Common,
    ProductLocationInvoicing,
    Storage,
    Extranet
}

export class ProductMainGroup implements IAutocompleteItem {

    constructor(id, databaseId, name) {
        this.id = id;
        this.databaseId = databaseId;
        this.name = name;
    }

    id: string;
    databaseId: number;
    name: string;

    getTitle(): string {
        return this.name;
    }

}

export  class MainGroups {
    private static readonly _commonId = Base.getGuid();
    private static readonly _invoicingId = Base.getGuid();
    private static readonly _storageId = Base.getGuid();
    private static readonly _extranetId = Base.getGuid();

    public static get common() { return new ProductMainGroup(MainGroups._commonId, MainGroupType.Common, t("common.commonType")); }
    public static get invoicing() { return new ProductMainGroup(MainGroups._invoicingId, MainGroupType.ProductLocationInvoicing, t("storage.invoice")); }
    public static get storage() { return new ProductMainGroup(MainGroups._storageId, MainGroupType.Storage, t("storage.product")); }
    public static get extranet() { return new ProductMainGroup(MainGroups._extranetId, MainGroupType.Extranet, t("common.extranet")); }
}
